export const getStudyTasksData = state => state.studyTasks.all;
export const getStudyTaskData = state => state.studyTasks.studyTask;
export const studyTasksIsFetching = state => state.studyTasks.loading.all;
export const studyTaskIsFetching = state => state.studyTasks.loading.studyTask;